import { Chip } from "@mui/material"

export function ScheduleLibraryFolderChip({ item, index, getTagProps }) {
    const tagProps = getTagProps({ index })
    return <Chip size="small" label={item?.name || ""} title={item?.path || ""} {...tagProps} />
}
